// extracted by mini-css-extract-plugin
module.exports = {"root":"languageSelect_root__16JYl","divider":"languageSelect_divider__1xRib","text":"languageSelect_text__3edSl"};